import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/react-hooks';
import { useGraphQLClient } from '../../graphql-client';
import SocialAuthCallbackBase from '../../SocialAuthCallback';
import { useConfig } from '../../context';
import { socialAuthPath } from '../../SocialAuthCallback/utils';
import { BootstrapGate } from '@shared/ui';
const SocialAuthCallback = () => {
    const client = useGraphQLClient();
    const { global: { socialAuthCallbackUrl } } = useConfig();
    const basename = socialAuthCallbackUrl ? `${new URL(socialAuthCallbackUrl).pathname}` : socialAuthPath;
    return (React.createElement(BootstrapGate, null,
        React.createElement(BrowserRouter, { basename: basename },
            React.createElement(ApolloProvider, { client: client },
                React.createElement(SocialAuthCallbackBase, { socialAuthCallbackUrl: socialAuthCallbackUrl })))));
};
export default SocialAuthCallback;
